var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBsTimeline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 21,
  viewBox: "0 0 30 21",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M20.5 18a1.5 1.5 0 0 1 0 3h-19a1.5 1.5 0 0 1 0-3zm8-6a1.5 1.5 0 0 1 0 3h-27a1.5 1.5 0 0 1 0-3zm-8-6a1.5 1.5 0 0 1 0 3h-19a1.5 1.5 0 0 1 0-3zm8-6a1.5 1.5 0 0 1 0 3h-27a1.5 1.5 0 0 1 0-3z"
})));
export default SvgBsTimeline;